<!--
 * @Author: your name
 * @Date: 2020-06-04 15:35:35
 * @LastEditTime: 2020-08-06 14:10:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/x-project-app/src/pages/app-config/fn-config/fn-config.vue
-->
<template>
  <div
    v-if="!computedComponentConfig.hidden || renderSence === 'ide'"
    class="form-build-item-wrapper"
    :class="wrapperClass"
  >
    <div v-if="renderSence === 'edit'" class="form-item-wrapper">
      <component
        ref="comp"
        :is="computedRenderSenceComponent"
        :renderSence="renderSence"
        :formData.sync="computedFormData"
        :globalData="globalData"
        :formConfigList="formConfigList"
        :propKey="widget.componentConfig.uuid"
        :validateKey="computedPropKey"
        :validateInfo="validateInfo"
        :widget="computedComponentConfig"
        :valueValidatedStatus="valueValidatedStatus"
        @formEventEmit="formEvent"
        @validate-changed="$emit('validate-changed', $event)"
      ></component>
    </div>
    <div v-if="renderSence === 'read'" class="form-item-wrapper">
      <component
        :is="computedRenderSenceComponent"
        :renderSence="renderSence"
        :formData.sync="computedFormData"
        :globalData="globalData"
        :propKey="widget.componentConfig.uuid"
        :widget="widget.componentConfig"
        :valueValidatedStatus="valueValidatedStatus"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XBusinessFormBuildItemWrapper',
  components: {
  },
  props: {
    widget: {
      type: Object,
      required: true
    },
    renderSence: {
      type: String,
      required: true,
      validator: function(value) {
        const renderSenceList = ['ide', 'edit', 'read']
        return renderSenceList.includes(value)
      }
    },
    itemClass: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {}
    },
    globalData: {
      type: Object
    },
    formConfigList: {
      type: Array
    },
    inTable: {
      type: Boolean,
      default: false
    },
    rowIndex: {
      type: Number
    },
    validateInfo: {
      type: Object
    },
    itemRuleConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      valueValidatedStatus: true
    }
  },
  computed: {
    computedRenderSenceComponent() {
      // if (this.widget.componentConfig.originComponentType === 'FORM_DATA_ASSIGNMENT') {
      //   return this.$formBuildEngine.getComponentConfigWithType(
      //     this.widget.componentConfig.originComponentType
      //   ).componentConfig.render[this.renderSence]
      // }
      return this.widget.componentConfig.render[this.renderSence]
    },
    computedPropKey() {


      if (this.inTable) {
        return `tableData.${this.rowIndex}.${this.widget.componentConfig.uuid}`
      } else {
        return `${this.widget.componentConfig.uuid}`
      }
    },
    computedComponentConfig: {
      get() {
        // 特殊逻辑，处理表格是否新建可编辑，如果formData中没有id
        let componentConfig = {
          ...this.widget.componentConfig
        }
        if (this.renderSence === 'edit' && this.inTable && !this.formData.id) {
          // if (this.widget.componentConfig.originComponentType === 'FORM_DATA_ASSIGNMENT') {
          //   componentConfig = {
          //     ...this.widget.componentConfig,
          //     componentType: 'FORM_DATA_ASSIGNMENT',
          //     placeholder: '自动赋值'
          //   }
          // }
          if (
            this.widget.componentConfig.onlyCreateEdit &&
            !this.widget.componentConfig.originReadOnly
          ) {
            componentConfig = {
              ...this.widget.componentConfig,
              readOnly: false
            }
          }
        }

        if (this.renderSence !== 'ide') {
          // debugger
          if (this.itemRuleConfig) {
            componentConfig = {
              ...componentConfig,
             readOnly:
                typeof this.itemRuleConfig.readOnly === 'undefined'
                  ? componentConfig.readOnly
                  : this.itemRuleConfig.readOnly,
              hidden:
                typeof this.itemRuleConfig.hidden === 'undefined'
                  ? componentConfig.hidden
                  : this.itemRuleConfig.hidden,
              required:
                typeof this.itemRuleConfig.required === 'undefined'
                  ? componentConfig.required
                  : this.itemRuleConfig.required
            }
          }
          if (JSON.stringify(componentConfig) === JSON.stringify(this.widget.componentConfig)) {
            return this.widget.componentConfig
          }
          return componentConfig
        }
        return this.widget.componentConfig
      },
      set(value) {
        if (this.widget.componentConfig.componentType === value.componentType) {
          this.widget.componentConfig = value
          this.$emit('update:widget', this.widget)
        }
      }
    },
    wrapperWidthClass() {
      return `form-item-wrapper-width${this.widget.componentConfig.width}`
    },
    wrapperHeightClass() {
      return `form-item-wrapper-height${this.widget.componentConfig.height}`
    },
    wrapperClass() {
      let wrapperClass = ''
      if (!this.widget.componentConfig.isInTable) {
        wrapperClass =
          wrapperClass +
          ` ${this.wrapperWidthClass} ${this.wrapperHeightClass} ${this.itemClass}
              ${this.renderSence} ${this.widget.componentConfig.render[this.renderSence]}`
      } else {
        wrapperClass =
          wrapperClass +
          ` ${this.itemClass} ${this.renderSence} ${
            this.widget.componentConfig.render[this.renderSence]
          }`
      }

      if (this.renderSence === 'read' && this.widget.componentConfig.noBorder) {
        wrapperClass = wrapperClass + ` border-none`
      }

      if (this.validateInfo && this.validateInfo.validate === 'error') {
        wrapperClass = wrapperClass + ` validate-error`
      }

      return wrapperClass
    },
    widgetIdeSenceWrapperClass() {
      return this.widget.componentConfig.hidden ? 'hidden-class-in-ide' : ''
    },
    computedFormData: {
      get() {
        return this.formData
      },

      set(value) {
        this.$emit('update:formData', value)
      }
    }
  },
  watch: {
    computedFormData: {
      handler(newValue, oldValue) {
        if (this.renderSence !== 'ide' && newValue) {
          if (
            this.widget.componentConfig.uuid !== `32bit uuid` &&
            this.widget.componentConfig.methods &&
            this.widget.componentConfig.methods.lcValidateValue
          ) {
            const value = newValue[this.widget.componentConfig.uuid]
            if (value !== undefined && value !== null) {
              this.valueValidatedStatus = this.widget.componentConfig.methods.lcValidateValue(
                value,
                this.widget.componentConfig
              )
              if (this.valueValidatedStatus === false) {
                console.warn(this.widget.componentConfig.label + '值校验失败')
              }
            }
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    clickOptions(actionName, $event) {
      this.$emit('formItemOptionAction', actionName)
      if ($event) {
        $event.stopPropagation()
        $event.preventDefault()
      }
    },
    handleComponentEvent(eventName, component) {
      this.$emit('handleComponentEvent', eventName, component)
    },
    formEvent(e) {
      this.$emit('formEventEmit', e)
    }
  }
}
</script>

<style lang="scss">
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, menu, nav, output, ruby, section, summary, time, mark, audio, video, input {
  z-index: 2;
}
</style>
